<template>
  <div>
    <Head title="Create Contact" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" :href="`/agencies/agencies/${parent_branch.id}/edit`">{{ parent_branch.name }}</Link>
      <span class="text-indigo-400 font-medium">/</span> {{ $t('message.general.create') }} Branch
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.code" :error="form.errors.code" class="pb-8 pr-6 w-full lg:w-1/2" label="Code" />
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Name" />
          <select-input v-model="form.location_id" :error="form.errors.location_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Location">
            <option :value="null" />
            <option v-for="location in locations" :key="location.id" :value="location.id">{{ location.name }}</option>
          </select-input>
          <!-- <select-input v-model="form.parent_id" :error="form.errors.parent_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Parent Branch">
            <option :value="null" />
            <option v-for="parent in parent_branches" :key="parent.id" :value="parent.id">{{ parent.name }}</option>
          </select-input> -->
          <text-input v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full lg:w-1/2" label="Address" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2" label="Phone" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Branch</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    locations: Array,
    parent_branch: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        code: '',
        name: '',
        location_id: null,
        parent_id: this.parent_branch.id,
        address: '',
        phone: '',
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/agencies/branches')
    },
  },
}
</script>
